import { render, staticRenderFns } from "./DocumentosComponent.vue?vue&type=template&id=603c609a&scoped=true"
import script from "./DocumentosComponent.vue?vue&type=script&lang=js"
export * from "./DocumentosComponent.vue?vue&type=script&lang=js"
import style0 from "./DocumentosComponent.vue?vue&type=style&index=0&id=603c609a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603c609a",
  null
  
)

export default component.exports